var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapperTwoRowTextWithIcon u-b0"},[(_vm.icon)?_c('Icon',{staticClass:"icon",attrs:{"type":_vm.icon}}):_vm._t("icon"),_c('div',[_c('p',{staticClass:"topRow u-b0"},[_vm._t("topRow")],2),_c('p',{staticClass:"bottomRow u-b2--"},[_vm._t("bottomRow")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }